import React from 'react';

const AdobeIllustratorIcon = ({ classes }) => (
  <svg className={classes} role="img" x="0px" y="0px"
	 viewBox="0 0 512 512" >
<g>
	<path d="M429.1,100.9c8.5-4.3,12.9-8.6,19.3-8.6c10.7,0,17.2,6.5,19.4,10.7c4.3,6.5,19.3,10.7,25.7,10.7c4.3,0,10.7-15,15-27.8
		c4.3-12.9,4.3-27.9,2.2-30.1c-2.2-2.1-19.4-6.5-23.6-6.5c-2.1,2.2-6.5,4.4-15,4.4c-8.5,0-17.2-6.5-23.6-12.9
		c-10.7-10.7-23.5-15-36.4-19.3c-12.8-4.4-27.9-4.4-40.7-4.4c-19.4-2.1-40.8-2.1-60.1,4.4c-8.5,2.1-15,4.3-23.6,8.5
		c-2.1,2.2-8.5,4.3-10.7,4.3c-2.1,2.2-2.1,4.3,0,4.3c2.2,0,10.7-2.1,10.7-2.1s-10.7,4.3-10.7,8.5c0,2.2,2.2,2.2,2.2,2.2
		s6.5-2.2,10.7-2.2c8.5,0,21.4-4.3,32.2-4.3c12.9,0,25.7,4.3,38.6,17.2c19.3,23.5,17.2,53.6,17.2,60.1
		c-4.4,45-105.2,319.6-109.5,338.9c-4.3,19.4-4.3,30.1,19.3,36.6c23.6,6.4,32.2,0,36.6-8.6C326.1,469.9,390.4,130.9,429.1,100.9
		L429.1,100.9z M345.5,79.4L0,133l55.8,358.3l184.4-30c-2.1-15.1,47.2-143.8,55.8-167.4l-94.5,15l12.9-38.6l66.6-10.7l17.1,21.4
		c0,0,4.4-10.7,4.4-15l-92.3-113.7c-4.3-6.5-4.3-15,2.1-19.3l4.4-4.3c6.4-4.4,15-4.4,19.3,2.1l81.5,94.5
		c17.2-51.6,32.2-96.5,32.2-111.7C351.8,109.4,351.8,94.4,345.5,79.4L345.5,79.4z M88,291.8l57.9-10.7l-15,38.6l-38.6,6.5L88,291.8z
		 M212.4,182.4l6.5,2.1c8.6,2.2,10.7,10.7,8.6,19.4l-64.4,171.6l-38.6,51.4l4.3-64.4l64.4-171.6
		C195.3,182.4,203.8,180.2,212.4,182.4L212.4,182.4z M444.1,122.3c-8.5,8.5-19.3,36.4-40.7,118h2.1l6.5,34.3l-17.2,2.2
		c-2.1,10.7-4.3,21.4-8.5,34.4c36.4,19.3,17.2,66.4,15,66.4c-2.1,0-2.1,0-2.1-2.1c0-2.2,2.1-8.6-4.4-10.7
		c-4.3-2.2-12.8-4.4-19.3-8.6c-6.5,25.7-12.9,55.8-19.3,88l135.1-21.4l-45-302.6L444.1,122.3z"/>
</g>
</svg>

);

export default AdobeIllustratorIcon;
